<ng-container *ngIf="membershipOptions$ | async as membershipOptions;">
    <div *ngFor="let option of membershipOptions">
      <label>
        <input
          type="radio"
          name="option.MembershipOptionId"
          class="registration-choose-membership-card-input-element d-none"
          [(ngModel)]="selectedOptionItem"
          [checked]="selectedOptionItem == option"
          [value]="option"
        />
        <div class="card card-body bg-light d-flex flex-row justify-content-between align-items-center rounded-sm">
          {{option.DisplayName}}
          <span>{{option.Description}}</span>
        </div>
      </label>
    </div>
  </ng-container>
  <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
